import { reactNodeToText } from 'utils/react';
import { ExportColumn } from 'utils/tables';

import { SearchFrameHashState } from 'types/hash-state';

import { ValueFacet } from './types';

export function flattenExportColumns<HitT>(columns: ExportColumn<HitT>[]) {
  return columns
    .reduce(
      (flattened: ExportColumn<HitT>[], column) =>
        // expand exportValue object into multiple export columns e.g `{'Item ID': 'itemId', 'Item Name': 'itemName'}`
        flattened.concat(
          typeof column.exportValue === 'object'
            ? Object.entries(column.exportValue).map(([subColTitle, subColExportValue]) => ({
                ...column,
                exportTitle: subColTitle,
                exportValue: subColExportValue,
              }))
            : [column],
        ),
      [],
    )
    .map((column) => ({
      ...column,
      // sanitize title & dataIndex to be string
      title: column.exportTitle || reactNodeToText(column.title),
      dataIndex:
        typeof column.exportValue === 'string'
          ? column.exportValue
          : Array.isArray(column.dataIndex)
          ? column.dataIndex[0]
          : column.dataIndex,
    }));
}

export function getFiltersWithDefaultFacetValues<HitT>(
  where: SearchFrameHashState['where'],
  valueFacets: (ValueFacet<HitT> | null)[],
): Obj<string[]> {
  const filters = { ...where };
  for (const facet of valueFacets) {
    if (facet?.defaultValue && !filters[facet.field]) {
      if (typeof facet.defaultValue === 'string') {
        filters[facet.field] = [facet.defaultValue];
      } else if (Array.isArray(facet.defaultValue)) {
        filters[facet.field] = facet.defaultValue;
      }
    }
  }
  return filters;
}
